module.exports = __webpack_public_path__ + "media/images/blog-13351a509e2c0d08cd7ce42f9af2c6c9.svg";